


























import { getCustomerCart, getCustomerCartPaymentUrl, GetCustomerCartResponse } from '@/classes/TayehApi/Customer';
import CartItem from '@/components/Cart/CartItem.vue';
import {Component, Vue} from 'vue-property-decorator'
@Component({
    components: {
        CartItem
    }
})
export default class PayCart extends Vue {
    customer_token: string|null = null;
    loading = false;
    cart: GetCustomerCartResponse|null = null;
    payment_url: string|null = null;

    
    public get currentIconClass() : string {
        return this.payment_url!==null?'ty-icon-arrow-up ty-color-success':!this.cart?'ty-icon-cart ty-color-dark-gray':'ty-icon-shop ty-color-primary'
    }
    
    
    public get currentStateText() : string {
        return this.payment_url!==null?'در حال انتقال به درگاه پرداخت':!this.cart?'در حال دریافت سبد خرید شما':'در حال بررسی سبد خرید شما'
    }
    

    async getCart () {
        try {
            const res = await getCustomerCart(this.customer_token)
            this.cart = res.data;
            if (!this.cart.payment_method||!this.cart.delivery?.address?.location?.verbal||null) this.$router.back()
            else {
                this.getPaymentUrl()
            }
        } catch (err) {
            console.log(err);
            this.$router.replace('/')
        }
        this.loading = false;

    }

    async getPaymentUrl () {
        try {
            const res = await getCustomerCartPaymentUrl(this.customer_token)
            if (!res.data.err) {
                if (!res.data.payment_url) {
                    this.$message.success('شما پرداخت درب منزل را انتخاب کرده اید. جهت تکمیل خرید فروشگاه با شما ارتباط برقرار خواهد کرد.')
                    this.$router.replace('/')
                } else {
                    window.location.href = res.data.payment_url;
                }
            } else {
                this.$message.error(res.data.err);
            }
        } catch (err) {
            console.log(err);
        }
    }

    created () {
        this.loading = true;
        this.customer_token = this.$route.query.customer as string;
        const next = this.$route.query.next;
        if (typeof next !== 'undefined' && next) {
            this.$store.commit('setPaymentRedirectUrl', next)
        }
    }

    mounted () {
        this.getCart()
    }
}
